import React from "react";
import ReactApexChart from "react-apexcharts";

const MIN_BAR_WIDTH = 50;

const CallOutcomesWidget = ({ callOutcomes = [] }) => {
  if (!callOutcomes.length) {
    return <p className="callOutcomesEmpty">No call outcomes data</p>;
  }

  const labels = callOutcomes.map(o => o.outcome);
  const counts = callOutcomes.map(o => o.count);
  const dynamicMax = Math.max(...counts, 1);
  const minWidth = labels.length * MIN_BAR_WIDTH;

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      animations: { enabled: false },
      selection: { enabled: false },
      zoom: { enabled: false }
    },
    plotOptions: {
      bar: {
        borderRadius: 3,
        columnWidth: "90%",
        distributed: true
      }
    },
    colors: ["#16a34a"],
    dataLabels: { enabled: false },
    legend: { show: false },
    xaxis: {
      categories: labels,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      min: 0,
      max: dynamicMax,
      tickAmount: 4,
      labels: {
        formatter: val => Math.round(val),
        style: { fontSize: "10px", colors: "#999" }
      }
    },
    grid: {
      borderColor: "#e8ebee",
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } }
    },
    tooltip: {
      x: { show: true },
      y: { formatter: val => `${val} calls` }
    }
  };

  const series = [{ name: "Calls", data: counts }];

  return (
    <div className="callOutcomesChartWrap">
      <div
        className="callOutcomesChartScroll"
        style={{ minWidth: `${minWidth}px` }}
      >
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={140}
          width="100%"
        />
      </div>
    </div>
  );
};

export default CallOutcomesWidget;
